import { createContext, useContext } from 'react';
import typeUtils from '../../../../../../ReactSharedScripts/utils/type';

export const StickyHeaderLayoutContext = createContext(false);

export function useStickyHeaderLayoutContext() {
	const context = useContext(StickyHeaderLayoutContext);

	return !typeUtils.isNullOrUndefined(context) && context;
}
